/**
 * 工具
 * 
 */
import {
    BigNumber
} from "bignumber.js";
import moment from 'moment';
import axios from 'axios'; // 引入axios
import { isEmptyArray, isNull } from "./validateBase";
import { provincesList } from "@/api/region"; // 获取区域请求
class Utils {
    static getFutureDate(futureDateNum = 0) {
      const resultDateNum = new Date(new Date().setDate(new Date().getDate() + futureDateNum * 1))
      const date = new Date(resultDateNum)
      return this.formatTime(date)
    }
    
    static formatTime(date, type = 'date') {
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hour = date.getHours()
      const minute = date.getMinutes()
      const second = date.getSeconds()
    
      return type === 'date' ? `${[year, month, day].map(this.formatNumber).join('-')}` : `${[year, month, day].map(this.formatNumber).join('-')} ${[hour, minute, second].map(this.formatNumber).join(':')}`
    }

    static formatNumber(n) {
        n = n.toString()
        return n[1] ? n : `0${n}`
    }
    /**
     * 标题闪烁
     * @param url 文件地址
     * @param name 文件标题
     */
    static dowLoadFile(url, name = '') {
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', name);
            // link.setAttribute('download', `${name}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        /**
         * 时间戳转日期
         * @param date 时间戳
         * @param timeType 精确到时分
         * @param timeTypeSecond 精确到秒
         */
    static timeToDate(date = Date.now(), timeType = true, timeTypeSecond = false, timeDetailBoo = false) {
            const oldDate = new Date()
            oldDate.setTime(date)
            const month = oldDate.getMonth() + 1
            let timeDetail = ''
            if (timeType) {
                let minutes = oldDate.getMinutes()
                let hours = oldDate.getHours()

                if (minutes < 10) {
                    minutes = '0' + minutes
                }
                if (hours < 10) {
                    hours = '0' + hours
                }

                timeDetail = ' ' + hours + ':' + minutes
                if (timeTypeSecond) {
                    let second = oldDate.getSeconds()
                    if (second < 10) {
                        second = '0' + second
                    }
                    timeDetail += ':' + second
                }
            }
            let returnData
            if (timeDetailBoo) {
                returnData = oldDate.getFullYear() + '-' + (month > 9 ? month : '0' + month) + '-' + (oldDate.getDate() > 9 ?
                    oldDate.getDate() : '0' + oldDate.getDate())
            } else returnData = oldDate.getFullYear() + '-' + month + '-' + oldDate.getDate() + timeDetail
            if (returnData == '1970-1-1 00:00' || returnData == '1970-1-1') {
                returnData = '暂无'
            }
            return returnData
        }
        /**
         * 计算精度问题处理
         * @param {*} operate 操作符
         * @param {*} a
         * @param {*} b
         * @param {*} bit 小数位数
         */
    static bigNumber(a, operate, b, bit) {
            let number = 0;
            a = a || 0
            b = b || 0
            switch (operate) {
                case '+':
                    number = Utils.plus(a, b)
                    break;
                case '-':
                    number = Utils.minus(a, b)
                    break;
                case '*':
                    number = Utils.multipliedBy(a, b)
                    break;
                case '/':
                    number = Utils.dividedBy(a, b)
                    break;
                case '%':
                    number = Utils.modulo(a, b)
                    break;
                default:
                    break;
            }
            if (bit || Utils.eq(bit, 0)) {
                number = Utils.toFixed(number, bit)
            }
            return number.toString()
        }
        /**
         * 
         * @param {*} a 
         * @param {*} b 
         * @returns 减
         */
    static minus(a, b) {
            a = new BigNumber(a);
            b = new BigNumber(b)
            return a.minus(b).toString()
        }
        /**
         * 
         * @param {*} a 
         * @param {*} b 
         * @returns 加
         */
    static plus(a, b) {
            a = new BigNumber(a);
            b = new BigNumber(b)
            return a.plus(b).toString()
        }
        /**
         * 
         * @param {*} a 
         * @param {*} b 
         * @returns 乘
         */
    static multipliedBy(a = 0, b = 0) {
            a = new BigNumber(a);
            b = new BigNumber(b)
            return a.multipliedBy(b).toString()
        }
        /**
         * 
         * @param {*} a 
         * @param {*} b 
         * @returns 除
         */
    static dividedBy(a, b) {
            a = new BigNumber(a);
            b = new BigNumber(b)
            return a.dividedBy(b).toString()
        }
        /**
         * 
         * @param {*} a 
         * @param {*} b 
         * @returns 取余
         */
    static modulo(a, b) {
            a = new BigNumber(a);
            b = new BigNumber(b)
            return a.modulo(b).toString()
        }
        /**
         * 
         * @param {*} num 
         * @param {*} bit 
         * @returns 
         */
    static toFixed(num, bit = 2) {
            let number = num;
            if (num) {
                number = new BigNumber(num).toFixed(bit)
            }
            return number
        }
        // 多个数字相加
    static sum(arr) {
            let sum = BigNumber.sum(...arr);
            return sum.toString()
        }
        // a大于b返回true
    static gt(a, b) {
            a = new BigNumber(a);
            b = new BigNumber(b)
            return a.comparedTo(b) > 0
        }
        // a小于b返回true
    static lt(a, b) {
            a = new BigNumber(a);
            b = new BigNumber(b)
            return a.comparedTo(b) < 0
        }
        // a等于b返回true
    static eq(a, b) {
            a = new BigNumber(a);
            b = new BigNumber(b)
            return a.comparedTo(b) == 0
        }
        // a不等于b返回true
    static ne(a, b) {
            a = new BigNumber(a);
            b = new BigNumber(b)
            return a.comparedTo(b) != 0
        }
        // a大于等于b返回true
    static ge(a, b) {
            a = new BigNumber(a);
            b = new BigNumber(b)
            return a.comparedTo(b) >= 0
        }
        // a小于等于b返回true
    static le(a, b) {
            a = new BigNumber(a);
            b = new BigNumber(b)
            return a.comparedTo(b) <= 0
        }
        // 计算，通过操作符
    static calc(operate, a, b) {
        return this[operate](a, b)
    }
    static cloneDeep(data) {
        let _new = JSON.parse(JSON.stringify(data))
        return _new
    }

    //判断是否跨月
    static judgeMonth(date) {
        let nowDate = new Date()
        let oldDate = new Date(date).getTime()
        let nowMonth = nowDate.getMonth() + 1;
        let oldMonth = new Date(oldDate).getMonth() + 1;
        if (Utils.gt(nowMonth, oldMonth)) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * 调用医保程序
     * @param {*} a 接口调用参数
     * @param {*} s 成功执行函数
     * @param {*} e 失败执行函数
     * @returns 
     */

    static jugeYBExecute() {
            let flag = true;
            return async function(work, success, error) {
                if (flag) {
                    flag = false
                    console.log('调用开始');
                    let result = await work();
                    if (result.data.code == 200) {
                        await success(result);
                    } else {
                        await error(result);
                    }
                    flag = true;
                    console.log('调用结束');
                } else {
                    await error();
                    console.log("不能重复调用");
                }
            }
        }
        //某天00:00的时间戳
    static startOfDay(time) {
            return _.toString(moment(time).startOf('day'))
        }
        //某天24:00的时间戳
    static endOfDay(time) {

            return _.toString(moment(time).endOf('day'))
        }
        //格式化
    static timeFormat(time, type = 'yyyy-MM-DD') {
            return _.toString(moment(time).format(type))
        }
        //获取省市区地址
    static getProvincesList() {
        return new Promise(async(resolve, reject) => {
            let list = JSON.parse(sessionStorage.getItem('provincesList'))
            if (isNull(list) || isEmptyArray(list)) {
                await provincesList().then(res => {
                    if (res.code == 200) {
                        list = res.rows
                        sessionStorage.setItem('provincesList', JSON.stringify(list))
                    } else {
                        list = []
                    }
                })
            }
            resolve(list)
        })
    }
    static estimateTakingDays (weight = 0, frequency = '', dosage = '') {
        const frequencyRegex = /^1日(.+)次$/
        const dosageRegex = /^每次(.+)g$/

        let frequencyCoefficient = 0
        let dosageCoefficient = 0

        const frequencyMatch = frequency.match(frequencyRegex)
        if (frequencyMatch) {
            frequencyCoefficient = Number(frequencyMatch[1]) || 0
        } else {
            const frequencyMap = {
                '2日1次': 0.5,
                '隔日1次': 2/3,
                '1周1次': 1/7,
                '1周2次': 2/7,
                '1周3次': 3/7,
                '隔周1次': 1/14
            }
            frequencyCoefficient = frequencyMap[frequency] || 0
        }

        const dosageMatch = dosage.match(dosageRegex)
        if (dosageMatch) {
            dosageCoefficient = Number(dosageMatch[1]) || 0
        } else {
            dosageCoefficient = 0
        }

        if ([0, '0', '', undefined, null].includes(weight) || [0, '0', '', undefined, null].includes(frequencyCoefficient) || [0, '0', '', undefined, null].includes(dosageCoefficient)) {
            return ''
        } else {
            const days = Math.trunc(weight / (frequencyCoefficient * dosageCoefficient))
            return days > 0 ? `服用${days}天` : ''
        }
    }
}

export { Utils }